/* eslint-disable complexity */
/* eslint-disable camelcase, max-lines, sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import { call, all, takeLatest, put, select, actionChannel, take } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getAlternateBrandName } from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.selectors';
import { isOptimizedDeleteEnabled, parseBoolean } from '@tcp/core/src/utils/utils';
import { getSessionStorage } from '@tcp/core/src/utils';
import { setLoaderState } from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import {
  setItemFromBagInfoForQuickView,
  setMultiPackDetails,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import BAG_SELECTORS from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import BagPageUtils from '@tcp/core/src/components/features/CnC/BagPage/views/Bagpage.utils';
import { getBossGCAndPreOrderCase } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import { getFavoriteStoreActn } from '@tcp/core/src/components/features/storeLocator/StoreLanding/container/StoreLanding.actions';
import { getUnbxdXappConfigs } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.saga';
import { getBundleData } from '@tcp/core/src/components/common/atoms/BundleTracker/container/BundleTracker.selector';
import { setLocalStorage, getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { resetTaxEstimationValue } from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import injectCouponDynamicStore from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/CouponDynamicStore';
import CARTPAGE_CONSTANTS from '../CartItemTile.constants';
import {
  getDefaultStoreData,
  getSFLId,
  getUserLoggedInState,
} from '../../../account/User/container/User.selectors';
import SpcSelector from '../../SinglePageCheckout/container/SinglePageCheckout.selector';
import {
  getIsPdpServiceEnabled,
  getABTestPdpService,
  getIsBundleTrackerEnabled,
  getIsStoreInventoryApi,
  getIsBOSSswitchEnabled,
  getABTestIsBOSSswitchEnabled,
  getIsApplyCheckboxPromoOnPDPEnabled,
  getIsLoyaltyTieringEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import {
  getStringAfterSplit,
  getMultipackCount,
  filterMultiPack,
} from '../../../../../utils/utils';
import CartItemTileSagaUtils from './CartItemTile.saga.utils';
import {
  updateCartItemComplete,
  getProductSKUInfoSuccess,
  setProductMultiPackData,
  setToggleCartItemError,
  clearToggleCartItemError,
  setBossBopisToggleCartItemError,
  clearToggleBossBopisCartItemError,
  setCartLoadingState,
  setTileLoadingState,
  setStoreUpdatingState,
  setStoreUpdateCompletedState,
  setShipmentProductInventoryDetails,
  scrollToTile,
  setBossCartFromCheckout,
  setApplePayCartLoadingState,
} from './CartItemTile.actions';
import {
  AddToPickupError,
  AddToCartError,
  clearAddToBagErrorState,
  clearAddToPickupErrorState,
  setAddedToBagDataLocal,
} from '../../AddedToBag/container/AddedToBag.actions';
import { filterItems } from '../../AddedToBag/container/AddedToBag.utils';
import {
  processMutationCachedDataSaga,
  getNonCachedCartDataSaga,
  processMutationNonCachedDataSaga,
} from '../../BagPage/container/BagPage.saga';
import BAG_PAGE_ACTIONS from '../../BagPage/container/BagPage.actions';
import { getProductSkuInfoByUnbxd } from '../../../../../services/abstractors/CnC/CartItemTile';
import {
  priceDropNotification,
  updateItem,
  updateStoreItem,
} from '../../../../../services/abstractors/SFCC/CartItemTile';
import BagPageSelectors from '../../BagPage/container/BagPage.selectors';
import BAGPAGE_CONSTANTS from '../../BagPage/BagPage.constants';
import {
  getMultiPackInventoryThreshold,
  getInventoryPayload,
  getCartOrderList,
} from './CartItemTile.selectors';
import getProductInfoById from '../../../../../services/abstractors/productListing/productDetail';
import {
  closePickupModal,
  openPickupModalWithValues,
} from '../../../../common/organisms/PickupStoreModal/container/PickUpStoreModal.actions';
import CHECKOUT_ACTIONS from '../../Checkout/container/Checkout.action';
import { getCouponList } from '../../common/organism/CouponAndPromos/container/Coupon.actions';
import { getErrorMessage } from '../../../../../utils/errorMessage.util';
import getBopisInventoryDetails from '../../../../../services/abstractors/common/bopisInventory/bopisInventory';
import {
  getParentAccessories,
  getParentCustomizationType,
  getSelectedAccessories,
  getUpdateType,
} from '../../../../common/molecules/Accessories/container/Accessories.selectors';
import {
  setParentAccessory,
  setCustomType,
} from '../../../../common/molecules/Accessories/container/Accessories.actions';
import { setBundleData } from '../../../../common/atoms/BundleTracker/container/BundleTracker.actions';
import { setDefaultStore } from '../../../account/User/container/User.actions';
import {
  confirmRemoveItemInChannel,
  removeCartItem,
  confirmRemoveItem,
} from './CartItemTileCommon.saga';
import { recalibrateSectionStates } from '../../SinglePageCheckout/container/SinglePageCheckout.actions';
import { getIsPickupModalOpen } from '../../../../common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import pushEventToAdobeAnalytics from '../../../../../adobeAnalytics/adobe.utils';
import { toastMessageInfo } from '../../../../common/atoms/Toast/container/Toast.actions';
import { checkForApplyAndRemoveCoupons } from '../../AddedToBag/container/AddedToBag.saga';
import { parseStoreHours } from '../../../../../utils/parseStoreHours';

const isOptimizedDelete = isOptimizedDeleteEnabled();

const getDefaultValue = (actualValue, defaultValue) => {
  return actualValue || defaultValue;
};

export function makeRegisteredUserCall(isMoveToSFL, userId) {
  return !isMoveToSFL && (!userId || userId === '-1002');
}

export function processDate(date) {
  let finalDate = date?.split('/')?.reverse();
  [finalDate[1], finalDate[2]] = [finalDate?.[2], finalDate?.[1]];
  finalDate = finalDate?.join('-');
  return finalDate;
}

export function localStorageBossDates(shipments) {
  let bossMinDate = null;
  let bossMaxDate = null;
  shipments.forEach((item) => {
    if (item?.bossMaxDate && item?.bossMinDate) {
      bossMaxDate = item?.bossMaxDate;
      bossMinDate = item?.bossMinDate;
    }
  });
  const store = shipments.find((shipment) => {
    if (shipment?.shipmentId !== 'me' && shipment?.itemsCount > 0) {
      return shipment;
    }
    return null;
  });

  const { shippingAddress } = getDefaultValue(store, {});
  const {
    address1 = '',
    city = '',
    phone = '',
    storePhoneNo = '',
    postalCode = '',
    c_storeName: storeName = '',
    stateCode = '',
    countryCode = '',
    c_fromStoreId = '',
    c_storeHours: storeHours = '',
  } = getDefaultValue(shippingAddress, {});
  const { storehours } = storeHours ? JSON.parse(storeHours) : { storehours: [] };
  const userStore = getDefaultValue(JSON.parse(getLocalStorage('defaultStore')), '');

  if (bossMinDate && bossMaxDate) {
    bossMinDate = processDate(bossMinDate);
    bossMaxDate = processDate(bossMaxDate);
    userStore.storeBossInfo = {
      startDate: bossMinDate,
      endDate: bossMaxDate,
      isBossEligible: true,
    };
  }
  if (address1) {
    userStore.basicInfo = {
      address: {
        addressLine1: address1,
        city,
        country: countryCode,
        state: stateCode,
        zipCode: postalCode,
      },
      phone: getDefaultValue(phone, storePhoneNo),
      storeName,
      id: getDefaultValue(c_fromStoreId, userStore?.basicInfo?.id),
      storeDiscount: userStore?.basicInfo?.storeDiscount,
    };
    userStore.hours = {
      regularHours: getDefaultValue(parseStoreHours(storehours), []),
      holidayHours: [],
      regularAndHolidayHours: getDefaultValue(parseStoreHours(storehours), []),
    };
  }
  setLocalStorage({ key: 'defaultStore', value: JSON.stringify(userStore) });

  return userStore;
}

export function makeCartApiCall(isMiniBag, pageName) {
  return isMiniBag || pageName === BAGPAGE_CONSTANTS.SHOPPING_BAG;
}

export const getBackPackIds = (orderItems = []) => {
  try {
    const parsedOrderItems = JSON.parse(JSON.stringify(orderItems)) || [];
    const backPackItemIds = [];
    if (parsedOrderItems) {
      parsedOrderItems.forEach((item) => {
        const { miscInfo, itemInfo } = item || {};
        const { c_accessories, c_mainProducts } = miscInfo || {};
        const { itemId } = itemInfo || {};
        if (c_accessories || c_mainProducts) {
          backPackItemIds.push(itemId);
        }
      });
    }
    return backPackItemIds;
  } catch (e) {
    return [];
  }
};

export function* removeCartItemFromLocal(response) {
  const cartItemsArray = yield select(BagPageSelectors.getOrderItemsLocal);
  const { orderItems = {} } = response;
  let cartItems = {};
  orderItems.forEach((element) => {
    cartItems = cartItemsArray.filter((item) => {
      const { itemInfo = {} } = JSON.parse(JSON.stringify(item));
      return itemInfo?.itemId !== element;
    });
  });

  if (JSON.stringify(cartItemsArray) === JSON.stringify(cartItems)) {
    cartItems = {};
    orderItems.forEach((element) => {
      cartItems = cartItemsArray.filter((item) => {
        const { itemInfo = {} } = JSON.parse(JSON.stringify(item));
        return itemInfo?.itemId !== element && itemInfo?.itemId !== undefined;
      });
    });
  }

  yield put(setAddedToBagDataLocal(cartItems));
}

export function* removeProductItems() {
  const deleteItem = yield actionChannel(CARTPAGE_CONSTANTS.CONFIRM_REMOVE_CART_ITEM);

  while (true) {
    try {
      const payload = yield take(deleteItem);
      yield call(confirmRemoveItemInChannel, payload);
    } catch (e) {
      logger.error(e);
      break;
    }
  }
}

/**
 *
 * @function updateSagaErrorActions
 * @description decided error actions on basis of result of update item call
 * @param {*} updateActionType
 * @param {*} errorMessage
 */
export function* updateSagaErrorActions(updateActionType, errorMessage, isCartTileQtyChange) {
  if (updateActionType && !isCartTileQtyChange) {
    yield put(AddToPickupError(errorMessage));
  } else {
    yield put(AddToCartError(errorMessage));
  }
}

export function* setUpdateItemErrorMessages(payload, errorMessage) {
  if (payload?.fromToggling) {
    yield put(
      setToggleCartItemError({
        errorMessage,
        itemId: payload?.apiPayload.orderItem[0].orderItemId,
      })
    );
  } else if (payload?.fromTogglingBossBopis && !payload.isCartTileQtyChange) {
    yield put(
      setBossBopisToggleCartItemError({
        errorMessage,
        itemId: payload?.apiPayload.orderItem[0].orderItemId,
        targetOrderType: payload?.apiPayload.x_updatedItemType,
      })
    );
  } else {
    yield put(AddToPickupError(errorMessage));
  }
}

export function* getFavoriteStoreCall(updateActionType, x_storeLocId) {
  const favStore = yield select(getDefaultStoreData);
  const favStoreId = favStore && favStore.basicInfo && favStore.basicInfo.id;
  if (updateActionType && x_storeLocId !== '' && x_storeLocId !== favStoreId) {
    yield put(
      getFavoriteStoreActn({
        ignoreCache: true,
        isForceUpdate: true,
      })
    );
  }
}

// eslint-disable-next-line complexity
/* eslint-disable max-statements */
export function* updateCartItemSaga({ payload }) {
  const {
    updateActionType,
    isMiniBagOpen,
    fromTogglingBossBopis,
    apiPayload: { x_storeLocId } = {},
    getAllNewMultiPack,
    getAllMultiPack,
    skuInfo,
    partIdInfo,
    isAddedToBag,
    itemId,
    isCartTileQtyChange,
    isCartPage,
    multiPackItems,
  } = payload;
  try {
    if (!isMiniBagOpen && !isAddedToBag && !isCartTileQtyChange) {
      yield put(setLoaderState(true));
    }
    if (isCartTileQtyChange || isMiniBagOpen) {
      yield put(setApplePayCartLoadingState(true));
      yield put(setCartLoadingState(true));
    }
    const isApplyCheckboxPromoOnPdp = yield select(getIsApplyCheckboxPromoOnPDPEnabled);
    yield put(BAG_PAGE_ACTIONS.setCartItemsUpdating({ isUpdating: true }));
    yield put(BAG_PAGE_ACTIONS.setCartItemData(payload));
    const multipackCatentryId = partIdInfo
      ? filterItems(getAllNewMultiPack, getAllMultiPack, skuInfo, partIdInfo)
      : multiPackItems || '';
    yield all([
      put(CHECKOUT_ACTIONS.setServerErrorCheckout({})),
      put(clearAddToBagErrorState()),
      put(clearAddToPickupErrorState()),
      put(clearToggleCartItemError()),
      put(clearToggleBossBopisCartItemError()),
    ]);
    const orderItems = yield select(getCartOrderList);
    const bundleDataItems = yield select(getBundleData);
    const isBundleTracker = yield select(getIsBundleTrackerEnabled);
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    const itemBrand = yield select(BagPageSelectors.getProductBrand, itemId);
    // UPDATE API pass params here
    const orderAccessoriesItem = yield select(BagPageSelectors.getorderAccessorieItems);
    const parentAccessorie = yield select(getParentAccessories);
    const parentCustomizationType = yield select(getParentCustomizationType);
    const updateTypeBoolean = yield select(getUpdateType);
    const { updatedItemResp, bundleData = [] } = yield call(
      updateItem,
      { ...payload, multipackCatentryId, itemBrand },
      errorMapping,
      orderAccessoriesItem,
      parentAccessorie,
      parentCustomizationType,
      updateTypeBoolean,
      { orderItems, bundleDataItems, isBundleTracker }
    );
    yield all([
      put(setBundleData(bundleData)),
      put(setParentAccessory([])),
      put(setCustomType('')),
    ]);
    const couponMap = updatedItemResp?.c_couponMap;
    const cartOrderItems = yield select(BagPageSelectors.getOrderItems);
    const productsData = BagPageUtils.formatBagProductsData(cartOrderItems);
    yield put(
      setClickAnalyticsData({
        customEvents: ['event68'],
        products: productsData,
        eventName: 'cart update',
        clickEvent: true,
      })
    );
    yield put(trackClick({ name: 'edit_cart', module: 'checkout' }));
    pushEventToAdobeAnalytics('bag_page_edit_click', productsData?.[0]);

    const { callBack } = payload;
    /* istanbul ignore else */
    if (callBack) {
      callBack();
    }
    yield call(processMutationCachedDataSaga, {
      payload: {
        respToProcess: updatedItemResp,
        isCartPage,
        skipStateUpdate: true,
      },
    });
    yield all([put(updateCartItemComplete()), put(setCartLoadingState(false))]);
    yield call(getNonCachedCartDataSaga, {
      payload: {
        respToProcess: updatedItemResp,
      },
    });
    yield put(setLoaderState(false));
    if (couponMap) {
      yield injectCouponDynamicStore();
      yield put(getCouponList({ ignoreCache: true, appliedCoupons: couponMap }));
    }
    if (isApplyCheckboxPromoOnPdp) {
      yield checkForApplyAndRemoveCoupons(true);
    }
    yield call(getFavoriteStoreCall, updateActionType, x_storeLocId);
    yield put(BAG_PAGE_ACTIONS.setCartItemsUpdating({ isUpdating: false }));
  } catch (err) {
    yield put(setApplePayCartLoadingState(false));
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    const errorMessage = getErrorMessage(err, errorMapping);
    if (!fromTogglingBossBopis || isCartTileQtyChange) {
      yield put(BAG_PAGE_ACTIONS.setCartItemsSflError(errorMessage));
    }
    yield call(updateSagaErrorActions, updateActionType, errorMessage, isCartTileQtyChange);
    yield setUpdateItemErrorMessages(payload, errorMessage);
    yield put(setLoaderState(false));
    yield put(BAG_PAGE_ACTIONS.resetBagLoadingState());
    yield put(setCartLoadingState(false));
  }
}

export function* handleAfterError(payload, errorMessage) {
  yield call(updateSagaErrorActions, '', errorMessage);
  yield setUpdateItemErrorMessages(payload, errorMessage);
  const { callback } = payload;
  if (callback) {
    callback();
  }
  yield put(toastMessageInfo(errorMessage));
  yield put(setStoreUpdateCompletedState(false));
}

// eslint-disable-next-line max-statements
export function* updateCartGroupItemSaga({ payload, enableModal }) {
  const { isScrollToTile, bossCartFromCheckout, ...rest } = payload;
  const { isCartPage, c_orderItemType, updateQuantity, isBossGCCase, isTileLevel } = payload;
  let requestPayload;
  let navigation;
  let navigationActions;
  try {
    requestPayload = payload.requestData;
    if (updateQuantity) {
      yield put(setApplePayCartLoadingState(true));
      yield put(setCartLoadingState(true));
    } else if (isBossGCCase) {
      navigation = payload?.navigation;
      navigationActions = payload?.navigationActions;
      yield put(setStoreUpdatingState(true));
    } else if (isTileLevel) {
      yield put(setTileLoadingState(isTileLevel));
    } else if (isCartPage) {
      yield put(setLoaderState(true));
    } else {
      requestPayload = rest;
      yield put(setStoreUpdatingState(true));
    }
    const isBossGCAndPreOrderCase = yield select(getBossGCAndPreOrderCase);
    yield put(CHECKOUT_ACTIONS.setServerErrorCheckout({}));
    yield put(clearAddToBagErrorState());
    yield put(clearAddToPickupErrorState());
    yield put(clearToggleCartItemError());
    yield put(clearToggleBossBopisCartItemError());

    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    const orderAccessoriesItem = yield select(BagPageSelectors.getorderAccessorieItems);
    const parentAccessorie = yield select(getParentAccessories);
    const parentCustomizationType = yield select(getParentCustomizationType);
    const updateTypeBoolean = yield select(getUpdateType);
    const orderItems = yield select(getCartOrderList);
    const bundleDataItems = yield select(getBundleData);
    const isBundleTracker = yield select(getIsBundleTrackerEnabled);
    const selectedAccessories = yield select(getSelectedAccessories);
    const isLoyaltyTieringEnabled = yield select(getIsLoyaltyTieringEnabled);
    const {
      updatedItemResp,
      bundleData = [],
      isLoyaltyBenefitsCacheUpdate,
      ...res
    } = yield call(updateStoreItem, requestPayload, isLoyaltyTieringEnabled, errorMapping, {
      orderAccessoriesItem,
      parentAccessorie,
      parentCustomizationType,
      updateTypeBoolean,
      orderItems,
      bundleDataItems,
      isBundleTracker,
      selectedAccessories,
    });
    yield put(setStoreUpdatingState(false));
    const userStore = localStorageBossDates(updatedItemResp?.shipments);
    yield put(setDefaultStore(userStore));
    yield put(setBundleData(bundleData));
    yield put(updateCartItemComplete(res));
    yield put(closePickupModal({ isModalOpen: false }));
    if (isScrollToTile) {
      yield put(scrollToTile(true));
    }
    yield call(processMutationCachedDataSaga, {
      payload: {
        respToProcess: updatedItemResp,
        isCartPage,
        skipCache: true,
        isLoyaltyBenefitsCacheUpdate,
      },
    });

    yield call(processMutationNonCachedDataSaga, {
      payload: {
        respToProcess: updatedItemResp,
        isCheckoutFlow: true,
      },
    });
    yield put(setLoaderState(false));
    yield put(setCartLoadingState(false));
    yield put(setStoreUpdateCompletedState(c_orderItemType));
    yield put(setTileLoadingState({ loading: false }));
    if (isBossGCAndPreOrderCase && enableModal) {
      yield put(BAG_PAGE_ACTIONS.startCheckout({ navigation, navigationActions, spcPage: true }));
    }
    const isSPC = yield select(SpcSelector.checkIsSinglePageCheckout);
    const isBossSwitch = yield select(getIsBOSSswitchEnabled);
    const isBosswitchAbTest = yield select(getABTestIsBOSSswitchEnabled);
    if (isSPC && isBossSwitch && isBosswitchAbTest) {
      yield put(recalibrateSectionStates());
    }
    yield put(closePickupModal({ isModalOpen: false }));
    const { callback } = payload;
    if (callback) {
      callback();
    }
    yield put(resetTaxEstimationValue());
    if (bossCartFromCheckout) {
      yield put(setBossCartFromCheckout(true));
    } else {
      yield put(setBossCartFromCheckout(false));
    }
  } catch (err) {
    yield put(setApplePayCartLoadingState(false));
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    let errorMessage = getErrorMessage(err, errorMapping);
    if (err.errorCodes === '_ERR_INVENTORY_NOT_AVAILABLE') {
      if (c_orderItemType === 'ECOM') {
        errorMessage = errorMessage.replace('#methodName', 'Shipping');
      } else {
        errorMessage = errorMessage.replace('#methodName', 'Ship to Store');
      }
    } else if (err.errorCodes === 'ERR_FAVORITE_STORE_CLOSED') {
      yield put(
        openPickupModalWithValues({
          fromBagPage: true,
          fromChangeStore: true,
          currentProduct: {
            ...rest,
          },
          isProductPickup: true,
          isBopisPickup: payload.toggle !== 'BOSS',
          pickupSelectedStore: {},
        })
      );
    }

    yield call(updateSagaErrorActions, '', errorMessage);
    yield setUpdateItemErrorMessages(payload, errorMessage);
    yield put(setStoreUpdatingState(false));
    yield put(setLoaderState(false));
    yield put(setApplePayCartLoadingState(false));
    yield put(setCartLoadingState(false));
    yield put(setTileLoadingState({ loading: false }));
    const { callback } = payload;
    if (callback) {
      callback();
    }
    const isPickupModalOpen = yield select(getIsPickupModalOpen);
    if (!isPickupModalOpen) {
      yield put(CHECKOUT_ACTIONS.setServerErrorCheckout({ errorMessage }));
    }
    yield put(setStoreUpdateCompletedState(false));
  }
}
export function fetchProductId(partId) {
  let multipleProduct = false;
  let newPartId;
  let multiplePartId = '';
  if (partId.includes(',')) {
    multipleProduct = true;
    const arrayOfPartNum = getStringAfterSplit(partId, ',');
    for (let i = 0; i < arrayOfPartNum.length; i += 1) {
      multiplePartId = multiplePartId.concat(getStringAfterSplit(arrayOfPartNum[i], '#')[0]);
      if (i !== arrayOfPartNum.length - 1) {
        multiplePartId = multiplePartId.concat(',');
      }
    }
  } else {
    newPartId = !!partId && [getStringAfterSplit(partId, '#')];
  }
  return multipleProduct ? multiplePartId : newPartId[0][0];
}

export function* shipmentProductInventory() {
  try {
    let formattedResponse = [];
    const payload = yield select(getInventoryPayload);
    const isStoreInventoryApiEnabled = yield select(getIsStoreInventoryApi);
    if (payload.productIds && payload.productIds.length) {
      const errorMapping = yield select(BAG_SELECTORS.getErrorMapping);
      formattedResponse = yield call(
        getBopisInventoryDetails,
        payload,
        errorMapping,
        isStoreInventoryApiEnabled
      );
    }
    yield put(setShipmentProductInventoryDetails(formattedResponse));
  } catch (err) {
    logger.error(err);
  }
}

export function* getProductSKUInfoSaga(payload) {
  try {
    yield put(setProductMultiPackData({}));
    const xappURLConfig = yield call(getUnbxdXappConfigs);
    const productId = payload.payload.productNum;
    const { itemBrand } = payload.payload;
    const isPdpServiceEnabled = yield select(getIsPdpServiceEnabled);
    const enablePDPServiceABTest = yield select(getABTestPdpService);
    let formattedResponse = yield call(
      getProductSkuInfoByUnbxd,
      productId,
      itemBrand,
      xappURLConfig,
      isPdpServiceEnabled,
      enablePDPServiceABTest
    );
    if (
      !!formattedResponse &&
      !!formattedResponse.product &&
      formattedResponse.product.multiPackUSStore
    ) {
      const partId = formattedResponse.product.tcpMultiPackReferenceUSStore;
      const finalPartId = fetchProductId(partId);
      const multiPackproductId = partId.split(',');
      const productIdCount = multiPackproductId[0].split(',');
      const multiPackCount = getMultipackCount(productIdCount);
      const state = yield select();
      const singleProduct = yield call(
        getProductInfoById,
        xappURLConfig,
        finalPartId,
        state,
        itemBrand,
        null,
        null,
        null,
        true,
        undefined,
        undefined,
        undefined,
        isPdpServiceEnabled,
        enablePDPServiceABTest
      );
      const multiPackInventoryThreshold = yield select(getMultiPackInventoryThreshold);
      formattedResponse = CartItemTileSagaUtils.applyMultiPackInfo(
        formattedResponse,
        singleProduct,
        multiPackCount,
        multiPackInventoryThreshold
      );
      yield put(setProductMultiPackData(formattedResponse));
    }
    yield put(getProductSKUInfoSuccess(formattedResponse));
  } catch (err) {
    logger.error(err);
  }
}

export function* priceDropNotificationSaga(payload) {
  let sflId = '';
  const isRegistered = yield select(getUserLoggedInState);
  if (isRegistered) {
    sflId = yield select(getSFLId);
    if (!sflId) {
      sflId = yield select(BAG_SELECTORS.getSflListId);
    }
  } else {
    sflId = yield select(BAG_SELECTORS.getSflListId);
    if (!sflId) {
      sflId = JSON.parse(getSessionStorage('SFL_ID'));
      if (!sflId) {
        sflId = JSON.parse(getLocalStorage('SFL_ID'));
      }
    }
  }

  try {
    yield call(priceDropNotification, { ...payload, sflId });
  } catch (err) {
    logger.error(err);
  }
}

/**
 *
 * @method openPickupModalFromBag
 * @description this method handles opening of pickup modal on click of edit from bag for boss/bopis item
 * @export
 * @param {*} payload
 */

const getMultipackProduct = (newfetchDetailArray) => {
  const filterData =
    newfetchDetailArray &&
    newfetchDetailArray.product &&
    newfetchDetailArray.product.categoryIdList;
  return filterData && filterMultiPack(filterData);
};

export function* openPickupModalFromBag(payload) {
  try {
    const {
      payload: {
        colorProductId,
        orderInfo,
        openSkuSelectionForm,
        isBopisCtaEnabled,
        isBossCtaEnabled,
        isItemShipToHome,
        alwaysSearchForBOSS,
        openRestrictedModalForBopis,
        isPickUpWarningModal,
        initialSelectedQty,
        newBag = false,
        isBopisPickup,
        isPickupStoreModalRedisgn,
        isBossPickupEdit,
        isPickUpSelected,
        fromEditModal,
      } = {},
    } = payload;
    let finalPartId = '';
    let partId;
    let newfetchDetailArray;
    let multiPackCount;
    if (!newBag) {
      yield put(setLoaderState(true));
    }

    const xappURLConfig = yield call(getUnbxdXappConfigs);
    const state = yield select();

    let itemBrand;
    if (orderInfo) {
      ({ itemBrand } = orderInfo);
    }
    yield put(
      setItemFromBagInfoForQuickView({
        orderInfo,
        fromBagPage: true,
        isSflProduct: payload.isSflProduct,
        isFavoriteEdit: payload.isFavoriteEdit,
        uniqueId: payload.colorProductId,
        pdpUrl: payload.pdpUrl,
        fromPage: payload.fromPage,
        sbpNavigation: payload.sbpNavigation || {},
        isSBP: payload.isSBP || false,
        fromAccessory: payload.fromAccessory || false,
        fromEditModal,
      })
    );
    if (newBag) {
      yield put(
        openPickupModalWithValues({
          productLoading: true,
          fromBagPage: true,
          initialValues: { ...orderInfo },
          generalProductId: colorProductId,
          fromEditModal,
        })
      );
    }

    const productDetail = yield call(
      getProductInfoById,
      xappURLConfig,
      colorProductId,
      state,
      itemBrand
    );
    let alternateBrand;
    let multiPackData = null;
    if (payload.fromPage !== 'pdp') {
      alternateBrand = getAlternateBrandName(state);
    }
    const { product } = productDetail || {};
    const currentProduct = product;
    const { generalProductId, multiPackUSStore, tcpMultiPackReferenceUSStore } =
      currentProduct || {};
    if (parseBoolean(multiPackUSStore)) {
      partId = tcpMultiPackReferenceUSStore?.join(',').split(',');
      const updatedPartId = new Set(partId);
      const findUpdatedPartId = [...updatedPartId];
      for (let k = 0; k < findUpdatedPartId?.length; k += 1) {
        finalPartId += `${fetchProductId(findUpdatedPartId[k])},`;
      }
      const isPdpServiceEnabled = yield select(getIsPdpServiceEnabled);
      const enablePDPServiceABTest = yield select(getABTestPdpService);
      const newMultiPackCount = findUpdatedPartId?.[0]?.split(',');

      multiPackCount = newMultiPackCount && getMultipackCount(newMultiPackCount);

      const multipackReferencesAPICall = true;
      newfetchDetailArray = yield call(
        getProductInfoById,
        xappURLConfig,
        finalPartId,
        state,
        itemBrand,
        undefined,
        undefined,
        undefined,
        multipackReferencesAPICall,
        partId,
        undefined,
        undefined,
        isPdpServiceEnabled,
        enablePDPServiceABTest,
        null,
        alternateBrand
      );
      multiPackData = newfetchDetailArray
        ? {
            newPartNumber: getMultipackProduct(newfetchDetailArray),
            multiPackCount,
            getMultiPackAllColor: product.getMultiPackAllColor,
            getNewMultiPackAllColor:
              newfetchDetailArray && newfetchDetailArray.product.getMultiPackAllColor,
            partIdDetail: newfetchDetailArray && newfetchDetailArray.product.partIdDetails,
          }
        : null;
      if (isBopisPickup) {
        yield put(setMultiPackDetails({ multiPackData }));
      }
    }
    yield put(
      openPickupModalWithValues({
        generalProductId,
        colorProductId: generalProductId,
        isBopisCtaEnabled,
        isBossCtaEnabled,
        currentProduct,
        fromBagPage: true,
        openSkuSelectionForm,
        initialValues: { ...orderInfo },
        updateCartItemStore: true,
        isItemShipToHome,
        alwaysSearchForBOSS,
        openRestrictedModalForBopis,
        isPickUpWarningModal,
        initialSelectedQty,
        productLoading: false,
        isBopisPickup,
        isPickUpSelected,
        isBossPickupEdit,
        fromEditModal,
        ...(!isBopisPickup ? { newPartNumber: { multiPackData } } : {}),
      })
    );
    if (!isPickupStoreModalRedisgn) {
      yield put(setLoaderState(false));
    }
  } catch (err) {
    yield put(setLoaderState(false));
  }
}

export function* CartPageSaga() {
  yield takeLatest(CARTPAGE_CONSTANTS.REMOVE_CART_ITEM, removeCartItem);
  yield takeLatest(CARTPAGE_CONSTANTS.PRICE_DROP_NOTIFICATION, priceDropNotificationSaga);
  yield takeLatest(CARTPAGE_CONSTANTS.UPDATE_CART_ITEM, updateCartItemSaga);
  yield takeLatest(CARTPAGE_CONSTANTS.GET_PRODUCT_SKU_INFO, getProductSKUInfoSaga);
  yield takeLatest(CARTPAGE_CONSTANTS.PICKUP_MODAL_OPEN_FROM_BAG, openPickupModalFromBag);
  yield takeLatest(CARTPAGE_CONSTANTS.UPDATE_STORE_ITEM, updateCartGroupItemSaga);
  yield takeLatest(CARTPAGE_CONSTANTS.SHIPMENT_PRODUCT_INVENTORY, shipmentProductInventory);
  if (isOptimizedDelete) {
    yield* removeProductItems();
  } else {
    yield takeLatest(CARTPAGE_CONSTANTS.CONFIRM_REMOVE_CART_ITEM, confirmRemoveItem);
  }
}

export default CartPageSaga;
